import React from 'react';
import { Auth } from 'aws-amplify';

export default function (Component) {
    return class extends React.Component {
      constructor(props){
        super(props);
        this.state = {
          user: null
        };
      }
  
      checkSession = async () => {
        console.log("Checking session")
        try {
          const data = await Auth.currentSession();
          // console.log(data);
          const { idToken } = data;
          this.setState({ user: { id: idToken.payload.sub, email: idToken.payload.email }});
        } catch (error) {
          console.error(error);
          Auth.signOut();
          window.location.reload();
        }
      }
  
      componentDidMount(){
        this.checkSession();
      };
  
      render() {
        return (
          <Component {...this.props} {...this.state} />
        ); 
      }
    };
}